import React from "react";

interface IPaginacaoProps {
  paginaAtual: number;
  totalPaginas: number;
  onPageChange: (pageNumber: number) => void;
}

const Paginacao: React.FC<IPaginacaoProps> = ({
  paginaAtual,
  totalPaginas,
  onPageChange,
}) => {
  const paginaAnterior = () => {
    if (paginaAtual > 1) {
      onPageChange(paginaAtual - 1);
    }
  };

  const proximaPagina = () => {
    if (paginaAtual < totalPaginas) {
      onPageChange(paginaAtual + 1);
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center">
      <button
        type="button"
        role="button"
        style={{ width: "100px" }}
        className="btn btn-primary me-2"
        onClick={paginaAnterior}
        disabled={paginaAtual === 1}
      >
        Anterior
      </button>
      <button
        type="button"
        role="button"
        style={{ width: "100px" }}
        className={`btn btn-primary${
          paginaAtual === totalPaginas ? " btn-disabled" : ""
        }`}
        onClick={proximaPagina}
        disabled={paginaAtual === totalPaginas}
      >
        Próxima
      </button>
    </div>
  );
};

export default Paginacao;
